export default "__VITE_ASSET__Dt5_2y$$__"